import { NavLink, Outlet } from "react-router-dom";
import { Logo, Button } from "@/design/components";
import { useOperatorAuth } from "./operatorAuth";
import styles from "./OperatorShell.module.css";

/** Operator console nav. Grows as screens land (Overview first; Organizations next). */
const NAV: { to: string; label: string; end: boolean }[] = [
  { to: "/operator/app", label: "Overview", end: true },
  { to: "/operator/app/orgs", label: "Organizations", end: false },
  { to: "/operator/app/mail", label: "Mailboxes", end: false },
  { to: "/operator/app/audit", label: "Activity", end: false },
];

/** Persistent operator-console layout (a React Router layout route). Visually distinct
 *  from the tenant portal — an "Operator" badge marks this as the platform-staff surface. */
export function OperatorShell() {
  const { operator, signOut } = useOperatorAuth();
  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <Logo size={24} />
          <span className={styles.badge}>Operator</span>
        </div>
        <nav className={styles.nav} aria-label="Operator">
          {NAV.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => [styles.link, isActive ? styles.active : ""].filter(Boolean).join(" ")}
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className={styles.body}>
        <header className={styles.topbar}>
          <span className={styles.realm}>Platform operator console</span>
          <div className={styles.account}>
            <span className={styles.email}>{operator?.email}</span>
            <Button variant="ghost" size="sm" onClick={signOut}>Sign out</Button>
          </div>
        </header>
        <main className={styles.main} id="main-content" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
